import RefreshIcon from '@mui/icons-material/Refresh';
import {
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ErpConversionGroupByType, OnRefresh } from '../types';

interface ErpDialogGroupingHeaderProps {
  value: ErpConversionGroupByType;
  onChange: (type: ErpConversionGroupByType) => void;
  onRefresh: OnRefresh;
}

export const ErpDialogGroupingHeader = (
  props: ErpDialogGroupingHeaderProps
) => {
  const { value, onChange, onRefresh } = props;
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: 'flex',
        gap: '0.5rem',
        alignItems: 'center',
        marginBottom: '0.5rem',
      }}
    >
      {value === 'SUPPLIER' && (
        <IconButton color="primary" onClick={() => onRefresh()}>
          <RefreshIcon />
        </IconButton>
      )}
      <Typography variant="caption">
        {' '}
        {t('COMMON.ERP.GROUP_VIEW_BY')}{' '}
      </Typography>
      <ToggleButtonGroup value={value} exclusive>
        <ToggleButton value="SUPPLIER" onClick={() => onChange('SUPPLIER')}>
          {t('COMMON.SUPPLIER')}
        </ToggleButton>
        <ToggleButton value="CONTRACT" onClick={() => onChange('CONTRACT')}>
          {t('COMMON.CONTRACT_one')}
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};
